/**
 * @prettier
 */

import React from 'react';
import ProductColorPicker from 'cards/components/common/ProductColorPicker/ProductColorPicker';
import { lookupSelectedVariation } from '../util/helpers';
import Canvas from './Canvas';
import styles from './styles.module.less';

// We need to import this directly to download the custom fonts when referenced in the preview.
import 'cards/stylesheets/_fonts.less';

const SamplePreview = ({
  hideColorPicker,
  colors,
  form,
  template,
  updateForm,
  sampleNotCustomizable,
  skuData,
  isMagnet,
  cardSuiteDetails,
}) => {
  const activeColor = form.customizations.color;

  const setColor = color => {
    const { variation } = form.customizations;
    const selectedOptions = { ...variation.option_values, color: color.value };

    const newVariation = lookupSelectedVariation(selectedOptions, cardSuiteDetails, isMagnet);

    updateForm({ customizations: { color: color.value, variation: newVariation } });
  };

  if (sampleNotCustomizable && skuData && skuData.image) {
    return (
      <div className={styles.box}>
        <div className={styles.centeredBox}>
          <div className={styles.previewBox}>
            <img className={styles.nonEditableImg} src={skuData.image} alt="sample preview" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.box}>
      <div className={styles.centeredBox}>
        <div className={styles.previewBox}>
          {template && (
            <Canvas page={template.pages[0]} customizations={form && form.customizations} />
          )}
        </div>
        <div className={styles.colorPickerBox}>
          {!hideColorPicker && (
            <ProductColorPicker
              colors={colors}
              activeColor={activeColor}
              maxColorsToShow={50}
              onSelect={setColor}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default SamplePreview;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SamplePreview/SamplePreview.jsx